import { useEffect, useRef, useState } from 'react';

export function GlobalApiLoader() {
  const [visible, setVisible] = useState(false);
  const showTimer = useRef<number | undefined>(undefined);

  useEffect(() => {
    const activity = (event: Event) => {
      window.clearTimeout(showTimer.current);
      if ((event as CustomEvent<number>).detail === 0) {
        setVisible(false);
      } else {
        showTimer.current = window.setTimeout(() => setVisible(true), 120);
      }
    };
    window.addEventListener('practice-api-activity', activity);
    return () => {
      window.clearTimeout(showTimer.current);
      window.removeEventListener('practice-api-activity', activity);
    };
  }, []);

  if (!visible) return null;
  return (
    <div className="global-api-loader" role="status" aria-live="polite">
      <span className="spinner" />
      <span>Loading...</span>
    </div>
  );
}
